import { GridToolbarContainer } from '@mui/x-data-grid-pro';
import React from 'react';

import { CustomSearchBarProps } from './CustomSearchBar.props';
import { TextField, TextFieldVariantProps } from '../../atoms/TextField';

export const CustomSearchBar: React.FC<CustomSearchBarProps> = ({
  value,
  handleChange
}) => {
  return (
    <GridToolbarContainer style={{ justifyContent: 'flex-end' }}>
      <TextField
        autoFocus={true} // eslint-disable-line jsx-a11y/no-autofocus -- intentional: primary search input on admin list pages
        placeholder="Search"
        value={value}
        variant={TextFieldVariantProps.Standard}
        onChange={handleChange}
      />
    </GridToolbarContainer>
  );
};